<template>
  <fragment>
    <div class="col-12">
      <div class="dash-section">
        <div class="header mb-2">
          <div>
            <h2 class="title">
              Notification Preferences
            </h2>
          </div>
        </div>
        <div class="dash-sub-section p-4 mx-lg-5">
          <b-table
            class="pref-table col-12"
            :fields="fields"
            :items="preferences"
            responsive
          >
            <template #cell(communicationType)="row">
              <b class="label">{{ row.item.label }}</b>
              <br>
              <span class="description">{{ row.item.description }}</span>
            </template>
            <template #cell(email)="row">
              <b-form-checkbox
                v-model="row.item.canEmail"
                size="lg"
                @change="preferencesModified()"
              >
              </b-form-checkbox>
            </template>
            <template slot="custom-foot">
              <tr>
                <td colspan="2" class="text-right">
                  <b-button
                    :disabled="!saveButtonEnabled || saving"
                    variant="secondary"
                    @click="save()"
                  >
                    <font-awesome-icon v-if="saving" :spin="true" :icon="['fas', 'spinner']" class="icon alt" />
                    <span v-else>Save Preferences</span>
                  </b-button>
                </td>
              </tr>
            </template>
          </b-table>
        </div>
      </div>
    </div>
  </fragment>
</template>

<script>
  export default {
    name: 'NotificationsTab',

    components: {

    },

    data() {
      return {
        saveButtonEnabled: false,
        saving: false,
        preferences: [],
        fields: [
          {
            key: 'communicationType',
            label: 'Notification',
            thClass: 'header-label',
            tdClass: 'align-middle col-lg-8'
          },
          {
            key: 'email',
            label: 'Email',
            thClass: 'text-center header-label',
            tdClass: 'align-middle text-center col-lg-4'
          }
        ],
        defaultPreferences: [
          {
            communicationType: 'ToCampusAdminAboutUserNoShow',
            label: 'User Did Not Attend Session',
            description: 'Receive a notification each time a user does not attend a scheduled session',
            canEmail: false
          },
          {
            communicationType: 'ToCampusAdminAboutUserLastAllowanceUsed',
            label: 'User Spent Last Individual Session Credit',
            description: 'Receive a notification when a user has used all of their allocated individual session credits',
            canEmail: false
          },
          {
            communicationType: 'ToCampusAdminAboutUserJoinedWithNoAllowance',
            label: 'User Registered Without Session Credits',
            description: 'Receive a notification when a user registers but does not have any available session credits',
            canEmail: false
          }
        ]
      }
    },
    async mounted() {
        this.setupPreferences();
    },
    methods: {
      async setupPreferences() {
        this.defaultPreferences.forEach(defaultPreference => {
          const preference = this.$user.communicationPreferences.preferences.find(p => p.communicationType === defaultPreference.communicationType);
          this.preferences.push(preference ?
                  {
                    ...defaultPreference,
                    canEmail: preference.canEmail,
                  } :
                  { ...defaultPreference });
          });
      },
      async save() {
        this.saving = true;
        try {
          this.$user.setCommunicationPreferences(
            this.preferences.map(({
              communicationType,
              canEmail
            }) => ({
              communicationType,
              canEmail,
              canSMS: false
            })
          ));
          this.alert('Preferences Saved Successfully!', false);
        } catch (ex) {
            this.alert('Failed to Update Preferences. Please try again!', true);
        } finally {
            this.saveButtonEnabled = false;
            this.saving = false;
        }
      },
      async preferencesModified() {
        this.saveButtonEnabled = true;
      },
      alert(message, e) {
            this.$store.commit('setGlobalAlert', {
                msg: message,
                error: e
            });
        }
    }
  };
  </script>

  <style lang="scss">
    .pref-table {
      border: 1px solid $blue;
      border-radius: 8px;
       thead tr th {
        border-bottom: 1px solid $blue !important;
      }

      tbody tr:first-child td{
        padding-top: 1.5rem;
      }

      .header-label {
        font-size: 1.15rem;
      }
      .label {
        font-size: 1.1rem;
      }
      .description {
        font-weight: 500;
        color: #76788e;
        border-bottom: 0;
        font-size: 0.9rem;
        letter-spacing: -0.01rem;
      }
    }
  </style>
